"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GlobalizedAlternates", {
    enumerable: true,
    get: function() {
        return _GlobalizedAlternates.default;
    }
});
const _GlobalizedAlternates = /*#__PURE__*/ _interop_require_default(require("./GlobalizedAlternates"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

//# sourceMappingURL=index.js.map